/* components/patterns/InvitationRow.jsx — строка приглашения.
   email + бейдж роли + срок действия + действия (Ссылка / Повторно / Отозвать).
   Роль доступа приглашения (assigned_role, T3) — глиф shield на бейдже: role_name
   уже несёт её имя из адаптера (у админа роль не действует — обычный бейдж статуса).
   Истёкшие — приглушены + бейдж «истекло». «Повторно» (resend) шлёт письмо заново и
   продлевает истёкший срок (бэк-эндпоинт). ХЕНДОФФ → components/settings/. */

import React from 'react';
import { useToast } from '../../app/providers/ToastProvider.jsx';
import { Pill } from '../ui/Badge.jsx';
import { Button } from '../ui/Button.jsx';
import { Icon } from '../ui/Icon.jsx';
import { fmt } from '../../lib/format.js';

  const { useState } = React;

  function InvitationRow({ invitation, canManage, onRevoke, onResend }) {
    const toast = useToast();
    const [copied, setCopied] = useState(false);
    const expired = invitation.is_expired;

    const copyLink = () => {
      const link = location.origin + '/invite/accept/' + invitation.token;
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(link);
      } catch (e) { /* демо */ }
      setCopied(true);
      toast.show('Ссылка-приглашение скопирована', 'success');
      setTimeout(() => setCopied(false), 1800);
    };

    return (
      <div className={'team-row team-row--invite' + (expired ? ' is-expired' : '')}>
        <span className="member-avatar member-avatar--ghost" aria-hidden="true"><Icon name="mail" size={16} /></span>
        <div className="team-row__id">
          <div className="team-row__name t-label num">{invitation.email}</div>
          <div className="team-row__email t-caption text-dim">
            {expired ? 'Срок действия истёк' : ('Действует до ' + fmt.date(invitation.expires_at))}
          </div>
        </div>
        {expired
          ? <Pill tone="bad" size="sm">Истекло</Pill>
          : invitation.assigned_role && !invitation.is_admin
            ? <Pill tone="info" size="sm" icon="shield">{invitation.role_name}</Pill>
            : <Pill tone={invitation.is_admin ? 'info' : 'neutral'} size="sm">{invitation.role_name}</Pill>}
        {canManage && (
          <div className="team-row__actions cluster cluster-4">
            {!expired && <Button variant="ghost" size="sm" iconLeft={copied ? 'check' : 'link'} onClick={copyLink}>{copied ? 'Скопировано' : 'Ссылка'}</Button>}
            {onResend && <Button variant="ghost" size="sm" iconLeft="refresh" onClick={() => onResend(invitation)}>Повторно</Button>}
            <Button variant="ghost" size="sm" iconLeft="trash" onClick={() => onRevoke && onRevoke(invitation)}>Отозвать</Button>
          </div>
        )}
      </div>
    );
  }

export { InvitationRow };
